import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import style from "./btn.module.css";
import { CreateBeneficiaryModal } from "./CreateBeneficiaryModal";

export const CreateBeneficiaryButton = observer(() => {
  const { companyCard, actionModals } = useStores();
  const { beneficiaryCreated } = companyCard.card;

  function showModalHandler() {
    actionModals.open(() => <CreateBeneficiaryModal />, {
      title: "Регистрация бенефициара",
      width: "600px",
      onApply: () => {
        return Promise.resolve();
      },
      onClose: () => actionModals.closeAll(),
    });
  }

  if (beneficiaryCreated) return null;

  return (
    <button onClick={showModalHandler} className={style.btn}>
      Зарегистрировать бенефициара
    </button>
  );
});
